import useGetExpiringNewsTips from './useGetExpiringNewsTips'
export default useGetExpiringNewsTips
